module.exports = __webpack_public_path__ + "Icono_Facturas_512px.png";